import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/app/[lang]/(withHeader)/coupon/_component/CouponNotFound.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/app/[lang]/(withHeader)/coupon/_component/Coupons.tsx");
